import { createApi,fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urlServer } from "../constants/endpoints";
import { clearAuth } from "../store/authSlice";

const baseQuery = fetchBaseQuery({
  baseUrl: "", // Impostiamo baseUrl a una stringa vuota perché lo selezioniamo dinamicamente sotto
  prepareHeaders: (headers,{ getState,endpoint }) => {
    let token = null;
    const tokeRegister = getState()?.auth?.token;
    const tokenGuest = getState()?.auth?.tokenGuest;

    if (tokeRegister) {
      token = tokeRegister;
    } else if (tokenGuest) {
      token = tokenGuest;
    }
    if (token) {
      headers.set("authorization",`Bearer ${token}`);
    }
    return headers;
  },
});
const baseQueryWithInterceptor = async (args,api,extraOptions = {}) => {
  const selectedBaseUrl = urlServer;
  args.url = `${selectedBaseUrl}${args.url}`;
  const headers = {
    ...(extraOptions?.headers || {}),
  };
  extraOptions.headers = headers;
  let result = await baseQuery(args,api,extraOptions);
  console.log("result",result)

  if (result.error && result.error.status === 401) {
    try {
      // Rimuove i token dai dati locali
      localStorage.removeItem("authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Pulisce anche lo stato Redux
      api.dispatch(clearAuth());
      // Reindirizza al login immediatamente
      if (typeof window !== "undefined") {
        window.location.replace("/login");
      }
    } catch (e) {
      console.warn("Failed to clear local auth on 401:", e);
    }
  }
  
  if (result.error && result.error.status !== 200) {
    console.log("Errore api:",result.error.data.code,result.error.data.message);
  }
  return result;
};
export const api = createApi({
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}),
  tagTypes: ["Post", "Playlist"],
});
